'use strict';

/**
 * blog list module
 */
require(['vue', 'blogListApp', 'vueLazyload', 'vueInfiniteScroll', 'es6PromiseAuto'], function (Vue, blogListApp, vueLazyload, vueInfiniteScroll) {
  /* eslint no-new: "off" */
  Vue.config.productionTip = false;
  Vue.use(vueLazyload, {
    preLoad: 1.3,
    // error: 'dist/error.png',
    loading: require.toUrl('images/lazyload/loading-bars.svg'),
    attempt: 2
  });
  Vue.use(vueInfiniteScroll);
  // 实例化vue
  new Vue({
    el: '#app',
    template: '<blogListApp/>',
    components: {
      blogListApp: blogListApp
    }
  });
});
define("Mageplaza_Blog/modules/blog-list", function(){});

